// Generated by scripts/buildFaIconCdn.ts — do not edit.
export const FA_ICON_VERSION = "7.1.0";
